import React, { useState } from 'react'
import { TargetTitle } from 'src/components/Global/Text/TitleText'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { validatePlanNameAction } from 'src/redux/actions/planAction'
import { action } from 'typesafe-actions'

import { SavingsSelectInput } from 'src/components/Global/SelectBox/Select'
import { CreateTargetWrapper, FormContainer } from './createTargetStyle'
import { useDispatch } from 'react-redux'
import { PlanTypes } from 'src/redux/types/planTypes'

const CreateTarget = () => {
  let location = useLocation()
  const options = [
    { value: 'general', label: 'General Savings' },
    { value: 'target', label: 'Target Savings' },
    { value: 'emergency', label: 'Emergency Savings' },
  ]

  const [planData, setPlanData] = useState({
    plan_name: '',
    plan_type: '',
    amount_to_save: '',
    device: 'web',
  })

  const { plan_name, amount_to_save, plan_type } = planData

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...planData }
    newData[name] = value
    setPlanData(newData)
    dispatch(action(PlanTypes._UPDATE_PLAN_FORM, newData))
  }

  const payload = {
    planName: {
      ...planData,
      //  account_name:getBankUserName.data?.account_name,
    },
  }
  const validatePlanName = (e: any) => {
    dispatch(validatePlanNameAction(payload))
  }

  const dispatch = useDispatch()

  let navigate = useNavigate()
  const handleSubmit = (e: any) => {
    e.preventDefault()
  }

  const Disabled = () => {
    if (!plan_name || !amount_to_save || !plan_type) {
      return 'blur'
    }
    return null
  }
  const Active = () => {
    if (!plan_name || !amount_to_save || !plan_type) {
      return <ModalButton className="target blur">Continue</ModalButton>
    }
  }
  return (
    <FormContainer>
      <CreateTargetWrapper onSubmit={handleSubmit}>
        <TargetTitle className="targetTitle">Create Plan</TargetTitle>
        <div className="input">
          <h4>Plan Type</h4>
          <SavingsSelectInput
            name="plan_type"
            value={plan_type}
            onChange={handleChange}
            placeholder="savings type"
          >
            {options?.map((option, index): any => (
              <option
                key={index}
                value={option.value}
                style={{ color: '#00085b' }}
              >
                {option.value}
              </option>
            ))}
          </SavingsSelectInput>
        </div>
        <div className="input">
          <h4>Plan Name</h4>
          <QuicksaveInput
            type="text"
            name="plan_name"
            value={plan_name}
            placeholder="Vacation"
            onChange={handleChange}
            onBlur={validatePlanName}
          />
        </div>
        <div className="input">
          <h4>Plan Amount</h4>
          <QuicksaveInput
            type="number"
            name="amount_to_save"
            value={amount_to_save}
            placeholder="#10000"
            onChange={handleChange}
          />
        </div>
        <div className="top">
          <Link
            to={'/create-target-continue'}
            state={{ backgroundLocation: location }}
          >
            <ModalButton className={`target ${Disabled()}`}>
              Continue
            </ModalButton>
          </Link>
        </div>
      </CreateTargetWrapper>
    </FormContainer>
  )
}
// {
//   ;`target ${Disabled()}`
// }

export { CreateTarget }
